import { BUILD_ENVIRONMENTS } from '@src/config/constants'
import { IS_PROD_BUILD } from '@src/config/env'
import { getCookieStorage } from '@src/utils/enhancedCookie'
import { isPreviewEnv } from '@src/utils/general.utils'

import { FEATURE_COOKIES } from './constants'
import isBrowser from './isBrowser'

export const DEFAULT_ENV = (IS_PROD_BUILD ? BUILD_ENVIRONMENTS.PROD : BUILD_ENVIRONMENTS.STAGE).toUpperCase()

/**
 * Resolves the `environment` query param used by several backend services.
 *
 * Default behavior is based on build-time env (PRODUCTION vs STAGING).
 * On preview hosts, if the `content-env` cookie is set, we use that value instead
 * so preview traffic can target the correct environment consistently.
 */
export function getContentProductsEnv(): string {
  const fallback = DEFAULT_ENV

  if (!isBrowser()) return fallback

  const contentEnv = getCookieStorage().getCookieLocalized(FEATURE_COOKIES.CONTENT_ENV, { isGlobal: true })
  if (!contentEnv) return fallback

  // Keep this consistent with `HttpClient` header injection:
  // only allow content-env overrides on preview hosts.
  if (!isPreviewEnv(window.location.hostname)) return fallback

  return contentEnv.toUpperCase()
}
